<script setup>
import { computed, ref } from "vue";
import InfiniteArticleList from "./components/ArticleList/InfiniteArticleList.vue";
import { useResultsStore } from "./stores/results";

const resultsStore = useResultsStore();

const isReloading = ref(true);

const props = defineProps({
  category: {
    type: String,
    required: true,
  },
});

const filters = computed(() => {
  return {
    categories: [props.category],
  };
});

async function init() {
  await resultsStore.fetchResults(filters.value);
  isReloading.value = false;
}

init();
</script>

<template>
  <InfiniteArticleList class="container" :filters="filters" :is-reloading="isReloading" />
</template>
